<a href="{{ cardUrl }}" #previewImageContainer class="flex justify-center items-center">
    <img class="mtg-card-rounded-sm sm:mtg-card-rounded card-shadow preview-hover" src="{{ cardImageUrl }}">
</a>